import Case from "@/models/SvcModels/Case";

export default class SspCase extends Case {
  static entity = "sspCases";
  static primaryKey = "uuid";

  static fields() {
    return {
      ...super.fields(),
      description: this.attr(null),
    };
  }
}
